import React from 'react';
import * as PropTypes from 'prop-types';
import CardItem from '../CardItem/CardItem';
import styles from './Products.module.less';

const Products = ({ products }) => {
  return (
    <div className={styles.products}>
      {products.map(item => {
        const { logoURL, displayName, summary, productIndexPage, name } = item;
        return (
          <CardItem
            key={name}
            summary={summary}
            avatarUrl={logoURL}
            name={displayName}
            productIndexPage={productIndexPage}
          />
        );
      })}
    </div>
  );
};

Products.propTypes = {
  products: PropTypes.array.isRequired
};

export default Products;
